var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m5dal70eaa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "90.749%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F13A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "17.965%",
    stopColor: "#F56D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62.316%",
    stopColor: "#FBA741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDA46"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ze0xc2pn9c",
    width: "114.6%",
    height: "114.6%",
    x: "-7.3%",
    y: "-7.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0.76452106 0 0 0 0 0.248180456 0 0 0 0 0.049720091 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "4oq46lsmyb",
    cx: 30,
    cy: 30,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "s3vc3ousad",
    d: "M13.414 0C5.081 0 0 1.313 0 6.188s3.455 6 13.414 6c9.96 0 13.211-2.338 13.211-6C26.625 1.313 21.747 0 13.415 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-1278 -603) translate(990 515) translate(288 88)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#m5dal70eaa)",
    xlinkHref: "#4oq46lsmyb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ze0xc2pn9c)",
    xlinkHref: "#4oq46lsmyb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1278 -603) translate(990 515) translate(288 88) translate(16.96 15.403) rotate(-15 75.975 4.638) translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5y49eeinfe",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3vc3ousad"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EFF3FC",
    xlinkHref: "#s3vc3ousad"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CED2DA",
    strokeLinecap: "round",
    strokeWidth: 1.875,
    d: "M1.626 6.188h22.763",
    mask: "url(#5y49eeinfe)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#471D18",
    d: "M2.53 0c-1.055 4.125 0 6.188 3.16 6.188-3.16 0-4.215 2-3.16 6H0V0h2.53z",
    mask: "url(#5y49eeinfe)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#471D18",
    d: "M23.463 0c-1.053 4.125 0 6.188 3.162 6.188-3.162 0-4.215 2-3.162 6h-2.529V0h2.53z",
    mask: "url(#5y49eeinfe)",
    transform: "matrix(-1 0 0 1 47.56 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1278 -603) translate(990 515) translate(288 88) translate(16.96 15.403) rotate(-5 30.32 .147)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.323,
    cy: 9.382,
    fill: "#401A16",
    rx: 3.188,
    ry: 5.063
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#401A16",
    d: "M22.4 11.597c1.761 0 3.188-.016 3.188-2.812s-1.427-5.063-3.187-5.063c-1.76 0-3.188 2.267-3.188 5.063s1.427 2.812 3.188 2.812z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#401A16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M0.126 0.718L10.469 8.145 10.399 4.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#401A16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M17.993 1.271L27.854 5.783",
    transform: "scale(-1 1) rotate(15.078 0 -169.69)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAngry);
export default __webpack_public_path__ + "static/media/emoji-angry.b0e38400.svg";
export { ForwardRef as ReactComponent };